export const URL = {
  // dev

  // API_BASE_URL: "http://localhost:7077",
  API_BASE_URL: "https://api.shreejrb.com",

  // public

  signinSeller: "/publicApi/signinSeller",

  // user authenticated
};
